module.exports = __webpack_public_path__ + "img/Caret-Down_Filled_16px_Grey_Icon.a86dcc4a.svg";